import React, { FC, useState, useEffect, useContext } from 'react'

import _ from 'lodash'
import { isMobile } from 'react-device-detect'
import history from '../../history'
import moment from 'moment'

import GenericBackgroundLayer from '../../GenericComponents/GenericBackgroundLayer'
import NavigationBar from '../NavigationBar/NavigationBar'
import GenericTextSpan from '../../GenericComponents/GenericTextSpan'
import GenericMainCard from '../../GenericComponents/GenericMainCard'
import GenericSwitch from '../../GenericComponents/GenericSwitch'
import GenericButton from '../../GenericComponents/GenericButton'
import GenericLogo from '../../GenericComponents/GenericLogo'
import GenericInput from '../../GenericComponents/GenericInput'
import GenericRange from '../../GenericComponents/GenericRange'
import GenericIcon from '../../GenericComponents/GenericIcon'
import GenericRow from '../../GenericComponents/GenericRow'

import AppContext from '../../context/appContext'
import changeLocation from '../../utils/changeLocalization'

import { ChatBoxBox, ChatBoxColumn } from '../ChatBox/style/ChatBoxStyle'

import TopNavbar from './elements/TopNavbar'
import TopBanner from './elements/TopBanner'
import JoinMiazgaSection from './elements/sections/JoinMiazgaSection'
import TransformationsSection from './elements/sections/TransformationsSection'
import PlatformsSection from './elements/sections/PlatformsSection'
import VideosSection from './elements/sections/VideosSection'
import StillHereSetion from './elements/sections/StillHereSetion'
import Footer from './elements/Footer'
import PromoBanner from './elements/sections/PromoBanner'

import cookie from 'react-cookies'

import { getPromoInfo } from '../../Api/backendApi'

interface LandingPageInterface {}

const LandingPage: FC<LandingPageInterface> = ({}) => {
  const appContext = useContext(AppContext)

  const [heroVideo, setHeroVideo] = useState<any>()
  const [promoInfo, setPromoIfno] = useState(null)

  useEffect(() => {
    redirectIfLogged()

    !isMobile && moveElements()
    landElements()
    scrollHeroImage()
  }, [])

  const obtainPromoInfo = async () => {
    const promoInfo = await getPromoInfo()

    await setPromoIfno(promoInfo)
  }

  const scrollHeroImage = () => {
    const heroImage: any = document.querySelector('.left-image')

    document.addEventListener('scroll', () => {
      heroImage.style.transform = `scale(${1 + window.scrollY / 5000})`
    })
  }

  const landElements = () => {
    const colElements = document.querySelectorAll('.element-col')

    document.addEventListener('scroll', () => {
      var position = colElements && colElements[0].getBoundingClientRect()
      var interval = 100

      if (
        position &&
        position &&
        position &&
        position.top >= 0 &&
        position &&
        position &&
        position &&
        position.bottom <= window.innerHeight
      ) {
        colElements[0].classList.add('visible')

        colElements.forEach((el, i) => {
          setTimeout(() => {
            !el.classList.contains('visible') && el.classList.add('visible')
          }, i * interval)
        })
      }
    })
  }

  const moveElements = () => {
    document.addEventListener('scroll', () => {
      const platformImage = document.getElementById('platformImage')
      var position = platformImage && platformImage.getBoundingClientRect()

      // checking whether fully visible
      if (
        position &&
        position.top >= 0 &&
        position &&
        position.bottom <= window.innerHeight
      ) {
      }

      // checking for partial visibility
      if (
        position &&
        position.top < window.innerHeight &&
        position &&
        position.bottom >= 0
      ) {
        platformImage.style.top = -150 + position.bottom / 5 + 'px'
      }
    })
  }

  // const getSingleVideo = async (type: string) => {

  //   const videoType = type == "topBanner" ? 458319235 : type == "appWorking" ? 669794776 : ''

  //   let singleVideo
  //   const getSingleVideoConfig: any = {
  //     method: 'GET',
  //     url: `${ApiURL}/api/vimeovideos/videos/${videoType}`,
  //     headers: {
  //       Authorization: 'Bearer ' + cookie.load('accessToken'),
  //     },
  //   }

  //   await axios(getSingleVideoConfig)
  //     .then((response) => {
  //       singleVideo = response.data
  //       console.log(response)
  //       type == "topBanner" ? setHeroVideo(response) : setAppVideo(response)
  //     })
  //     .catch(({ error, response }) => {
  //       console.log(error)
  //       console.log(response)

  //       // if (error.status == 401) {
  //       //   // refreshToken()
  //       //   // this.getSingleVideo()
  //       // } else {
  //       //   console.log(error)
  //       // }
  //     })
  //   return singleVideo
  // }

  const redirectIfLogged = () => {
    const isLoggedIn: boolean = cookie.load('accessToken') ? true : false

    if (isLoggedIn) {
      history.push('/redirect')
    }
  }

  return (
    <GenericBackgroundLayer
      fDir={'column'}
      justify={'flex-start'}
      align={'center'}
      className={`${
        appContext.appState.theme == 'light' ? 'light' : 'standard'
      } landing`}
    >
      {/* {moment(new Date()).isBefore('2022-09-01') &&
        moment(new Date()).isAfter('2022-08-20') && <PromoBanner landing />} */}
      {/* <PromoBanner landing /> */}
      <TopNavbar />
      <TopBanner heroVideo={heroVideo} />
      <JoinMiazgaSection />
      <TransformationsSection />
      <PlatformsSection />
      <VideosSection />
      <StillHereSetion />
      <Footer />
    </GenericBackgroundLayer>
  )
}

export default LandingPage
